import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { UserOrganization } from 'interfaces/user-organization'
import { userOrganizationsKeys } from 'utils/query-keys'

type Data = {
  data: {
    user_organizations: UserOrganization[]
  }
}

const fetchUserOrganizations = async (organizationId: string) => {
  let response = await fetch(
    `${BASE_API_URL}/api/v2/organizations/${organizationId}/user_organizations`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  const json: Data = await response.json()
  return json
}

export const useGetOrganizationUsers = (organizationId: string) => {
  return {
    ...useQuery(
      userOrganizationsKeys.detail(organizationId),
      () => fetchUserOrganizations(organizationId),
      {
        enabled: !!organizationId,
      }
    ),
  }
}
